function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { FilterTools } from '../../Header/FilterTools';
import { SortTools } from '../../Header/SortTools';
import { Stack } from '../../../Stack';
import { ElevatedStack } from '../../../Stack/ElevatedStack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TableHeader = _ref => {
  let {
    headerGroups,
    sticky,
    stickTopPx = 0
  } = _ref;
  return /*#__PURE__*/_jsx(ElevatedStack, {
    horizontal: true,
    styles: sticky ? {
      root: {
        position: 'sticky',
        zIndex: 1,
        top: "".concat(stickTopPx, "px"),
        background: 'white'
      }
    } : undefined,
    children: headerGroups.map(headerGroup => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps({
      style: {
        paddingTop: '10px'
      }
    })), {}, {
      children: headerGroup.headers.map(column => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, column.getHeaderProps()), {}, {
        children: /*#__PURE__*/_jsxs(Stack, {
          horizontal: true,
          children: [column.render('Header'), /*#__PURE__*/_jsx(SortTools, {
            headerGroup: column
          }), /*#__PURE__*/_jsx(FilterTools, {
            headerGroup: column
          })]
        })
      })))
    })))
  });
};